// Coexistence bridge: lets the legacy DashboardLayout know it's being rendered INSIDE
// the Console shell, so it renders its children bare instead of adding a second header
// (and a second, legacy Logout button that would wipe the Console session).
//
// TEMPORARY. Deleted together with DashboardLayout at the Step-12 cutover, once the
// standalone legacy routes are gone and the reused screens render content-only.
import { createContext, useContext } from "react";

export const InsideConsoleContext = createContext(false);

export function useInsideConsole() {
  return useContext(InsideConsoleContext);
}
